import React from "react"
import * as styles from "./brand.module.scss"
import TextBlock from "../TextBlock/TextBlock"
import { useLocale } from "../../hooks"
import Img from "gatsby-image"
const SectionHeading = ({
  headingLevel,
  children,
  headingAlignmentleft,
  faqComponent,
}) => {
  const locale = useLocale()
  return headingLevel == 1 ? (
    <h1
      className={`heading heading-1 ${
        headingAlignmentleft ? "text-left" : "text-center"
      }`}
    >
      {children}
    </h1>
  ) : headingLevel == 2 ? (
    <h2
      className={`${faqComponent ? styles.faqComponent : "heading"} heading-2 ${
        headingAlignmentleft ? "text-left" : "text-center"
      } ${locale === "en-US" || locale === "es-US" ? styles.padding : ""} `}
    >
      {children}
    </h2>
  ) : (
    <h3
      className={`heading heading-3 ${
        headingAlignmentleft ? "text-left" : "text-center"
      }`}
    >
      {children}
    </h3>
  )
}
export const Brand = ({ data, faqComponent, extraClass }) => {
  const {
    title,
    headingAlignmentLeft,
    wideDescription,
    headingLevel,
    description,
    images,
  } = data

  return (
    <div className={`component ${styles.brand} ${styles[extraClass]}`}>
      <div
        className={`container ${
          wideDescription ? "container-lg" : "container-md"
        }`}
      >
        {
          <SectionHeading
            headingAlignmentleft={headingAlignmentLeft}
            headingLevel={headingLevel}
            {...(faqComponent ? "true" : "")}
          >
            {title}
          </SectionHeading>
        }
        {images && (
          <div className={styles.logoWrapper}>
            {/* <GatsbyImage
              image={images[0].gatsbyImageData}
              alt={images[0].title || "image"}
            /> */}
             <Img 
                fluid={images[0].fluid} 
                alt={images[0].title || "image"}
                className={styles.brandImageLogo}
            />
          </div>
        )}
        <TextBlock
          data={description}
          wideDescription={wideDescription}
          faqComponent={faqComponent}
        />
      </div>
    </div>
  )
}
